import React from 'react';
import FormGroup from './FormGroup';

export interface FormCheckBoxProps {
  label?: string;
  description?: string;
  register?: any;
  name?: string;
  getValues?: (name: string) => unknown;
  setValue?: (name: string, value: boolean) => void;
  required?: boolean;
  checked?: boolean;
  helpContent?: React.ReactNode;
  testId?: string;
}

const FormCheckBox = ({
  label,
  description,
  register,
  name,
  getValues,
  setValue,
  required,
  checked,
  helpContent,
  testId,
}: FormCheckBoxProps) => {
  const handleOnClick = () => {
    if (name && getValues && setValue) {
      const value = getValues(name);
      setValue(name, !value);
    }
  };
  return (
    <FormGroup label={label} helpContent={helpContent}>
      <input
      {...(name != null && register ? register(name, { required }) : {})}
      aria-label={label}
      name={name}
      type="checkbox"
      checked={checked}
      required={required}
      data-cy={testId}
      />
      <label
        style={{ borderTop: '0px' }}
        onClick={handleOnClick}
        className={required ? 'required' : ''}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleOnClick();
          }
        }}
      >
        <span></span>
        {description || label}
      </label>
    </FormGroup>
  );
};
export default FormCheckBox;
